import * as React from 'react';
import './index.css';
export default class ErrorBoundary extends React.PureComponent {
    componentDidCatch(error) {
        this.props.logError(error);
    }
    render() {
        if (this.props.error) {
            return (React.createElement("div", { id: "error-indicator", onClick: this.props.toggleDebugPane }, this.props.error.message));
        }
        return this.props.children;
    }
}
